import { connect } from 'react-redux';
import MapScatterplot from './MapScatterplot';
import {
  getTimeIntervals,
  getSingleValueData,
  getHighlightTimestamps,
} from '../../selectors/crimes';
import { getCities } from '../../reducers/cities';
import { getCityCrimesPending } from '../../reducers/crimes';
import { getTotalTimespanInterval } from '../../selectors/intervals';
import { getShowPartialData } from '../../selectors/options';

export default connect(state => ({
  pending: getCityCrimesPending(state),
  cities: getCities(state),
  mainValues: getSingleValueData(state),
  timeIntervals: getTimeIntervals(state),
  highlightTimespans: getHighlightTimestamps(state),
  totalTimespan: getTotalTimespanInterval(state),
  showPartialData: getShowPartialData(state),
}))(MapScatterplot);



// WEBPACK FOOTER //
// ./src/components/MapPage/MapScatterplotContainer.jsx